import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { salesProof, type RecentPurchase } from '../data/salesProof';
const FIRST_DELAY = 12000;
const VISIBLE_FOR = 6000;
const randomGap = () => 25000 + Math.random() * 15000;

/** Notificación de compra: rota SOLO compras reales cargadas en data/salesProof.ts. No aparece si la lista está vacía. */
export function PurchaseToast() {
  const purchases = salesProof.recentPurchases;
  const [current, setCurrent] = useState<RecentPurchase | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (purchases.length === 0 || dismissed) return;
    let index = 0;
    let showTimer: number;
    let hideTimer: number;
    const show = () => {
      setCurrent(purchases[index % purchases.length]);
      index += 1;
      hideTimer = window.setTimeout(() => {
        setCurrent(null);
        showTimer = window.setTimeout(show, randomGap());
      }, VISIBLE_FOR);
    };
    showTimer = window.setTimeout(show, FIRST_DELAY);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
    };
  }, [purchases, dismissed]);
  return <AnimatePresence data-id="element-342" data-mp="237z6mdap1bsa">
      {current && !dismissed && <motion.div role="status" initial={{
      opacity: 0,
      y: 12,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 12,
      scale: 0.96
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-[96px] left-3 right-3 z-50 flex items-center gap-3 rounded-2xl border border-teal-soft bg-white p-3 pr-2 shadow-soft sm:right-auto sm:max-w-sm md:bottom-5 md:left-5" data-id="element-343" data-mp="286ioo2m623fd">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-teal-light" data-id="element-344" data-mp="rsk8h66r0dvl">
            <BadgeCheckIcon aria-hidden="true" className="h-5 w-5 text-teal-dark" data-id="element-345" data-mp="wqbz7wvnpty7" />
          </span>
          <div className="min-w-0 flex-1" data-id="element-346" data-mp="2017y62kdgy0i">
            <p className="text-xs font-bold uppercase tracking-wide text-teal-dark" data-id="element-347" data-mp="2006oa1f3ehkd">Compra verificada</p>
            <p className="truncate text-sm font-semibold text-navy" data-id="element-348" data-mp="1v0u11fkb78h9">
              {current.name} de {current.city}
            </p>
            <p className="truncate text-sm text-navy-soft" data-id="element-349" data-mp="24szsmo6nfnvx">compró 30 Días de Viandas Resueltas</p>
          </div>
          <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-navy-soft transition-colors duration-150 ease-out hover:bg-teal-soft" data-id="element-350" data-mp="1h2dhup59fpi8">
            <XIcon className="h-4 w-4" data-id="element-351" data-mp="1l3pbd5r98uvp" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}